/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Components
import { Navigate, Route, Routes } from "react-router-dom";
import SettingsHome from "./SettingsHome/SettingsHome";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { userHasPermission } from "config/userPermissions";
import { SETTINGS_MODULES } from "./utils/constants";
//#endregion
import useDashboardContext from "routes/utils/context/useDashboardContext";

const Settings = () => {
    const { user } = useDashboardContext();
    const userRole = user.role.id;
    //#region States
    const [routes, setRoutes] = useState(null);
    //#endregion
    //#region Effects
    useEffect(() => {
        setRoutes(getRoutes());
    }, []);
    //#endregion
    //#region Functions
    const getRoutes = () => {
        const newRoutes = [
            <Route 
                key={0}
                path="" 
                element={<SettingsHome userRole={userRole}/>}/>
        ];
        // Llenando rutas
        SETTINGS_MODULES.forEach(MODULE => {
            if (!userHasPermission(userRole, MODULE.id)) return;
            newRoutes.push(
                <Route 
                    key={newRoutes.length}
                    path={MODULE.path} 
                    element={<MODULE.View userRole={userRole}/>}/>
            );
        });
        return newRoutes;
    }
    //#endregion
    return (
        <Routes>
            {routes}
            {routes !== null && (
                <Route 
                    path="*" 
                    element={<Navigate to={ABSOLUTE_PATHS.SETTINGS} replace/>}/>
            )}
        </Routes>
    );
}

export default Settings;